/*
 * https://github.com/backstage/backstage/blob/master/plugins/notifications/src/components/NotificationsTable/SeverityIcon.tsx
 */
import { NotificationSeverity } from '@backstage/plugin-notifications-common';
import NormalIcon from '@mui/icons-material/CheckOutlined';
import CriticalIcon from '@mui/icons-material/ErrorOutline';
import HighIcon from '@mui/icons-material/WarningOutlined';
import LowIcon from '@mui/icons-material/InfoOutlined';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  critical: {
    color: theme.palette.status.error,
  },
  high: {
    color: theme.palette.status.warning,
  },
  normal: {
    color: theme.palette.status.ok,
  },
  low: {
    color: theme.palette.status.running,
  },
}));

export const SeverityIcon = ({
  severity,
}: {
  severity?: NotificationSeverity;
}) => {
  const classes = useStyles();

  switch (severity) {
    case 'critical':
      return <CriticalIcon className={classes.critical} />;
    case 'high':
      return <HighIcon className={classes.high} />;
    case 'low':
      return <LowIcon className={classes.low} />;
    case 'normal':
    default:
      return <NormalIcon className={classes.normal} />;
  }
};
